module.exports = __webpack_public_path__ + "static/media/type-2.e2e57787.svg";